export const SUCCESS = Symbol('success');
export const INFO = Symbol('info');
export const WARNING = Symbol('warning');
export const ERROR = Symbol('error');
